export default "__VITE_ASSET__078242c4__"